import styled, { css } from "styled-components"

export const Page = styled.div<{configuring: boolean}>`
  height: 100vh;
  overflow: scroll;
  ${({configuring}) => configuring && css`background-color: #e8e9f1;`}
  
`
